import { FormattedMessage, useIntl } from 'react-intl';

import { useAppDispatch, useAppSelector, useMedia } from '@/shared/hooks';
import { Button, Modal } from '@/shared/ui';

import { ModalID, modalModel } from '@/entities/modal';
import { StudyInfo, studyModel } from '@/entities/study';

import styles from './RawMeshViewerInfoModal.module.scss';

export const RawMeshViewerInfoModal = () => {
  const dispatch = useAppDispatch();
  const { formatMessage } = useIntl();
  const { isMobile } = useMedia();

  const {
    visible,
    data: { studyID, canDelete, onRemove },
  } = useAppSelector(modalModel.selectors.selectRawMeshViewerInfoModal);

  const study = useAppSelector((state) =>
    studyModel.selectors.selectById(state, studyID),
  );

  const closeModal = () => {
    dispatch(modalModel.actions.closeModal(ModalID.RawMeshViewerInfo));
  };

  const handleRemove = () => {
    closeModal();
    onRemove();
  };

  if (!study) {
    return null;
  }

  const showMobileFooter = isMobile && canDelete;

  return (
    <Modal
      data-component="raw-mesh-info-modal"
      headerClassName={styles.header}
      bodyClassName={styles.body}
      footerClassName={styles.footer}
      isOpen={visible}
      onCancel={closeModal}
      title={formatMessage({
        id: 'reportCard.information',
        defaultMessage: 'Information',
      })}
      hideFooter={!showMobileFooter}
      borderless={isMobile}
      footer={
        showMobileFooter ? (
          <Button danger variant="tertiary" onClick={handleRemove}>
            <FormattedMessage id="global.delete" defaultMessage="Delete" />
          </Button>
        ) : null
      }
    >
      <StudyInfo
        ID={study.ID}
        studyType={study.Type}
        uploadDate={study.Created?.At?.toDate()}
        studyTime={study.Time?.toDate()}
        showViewIntraoralScanButton
      />
    </Modal>
  );
};
